import 'babel-polyfill';
import {BodyComponent} from "../components/body/body-component";
import {Form} from "../components/form/form";
import {FormField} from "../components/form-field/form-field";
import {FormFieldChecks} from "../components/form-field-checks/form-field-checks";
import {FormFieldDate} from "../components/form-field-date/form-field-date";
import {FormFieldInput} from "../components/form-field-input/form-field-input";
import {FormFieldRadio} from "../components/form-field-radio/form-field-radio";
import {FormFieldSelect} from "../components/form-field-select/form-field-select";
import {FormFieldTextarea} from "../components/form-field-textarea/form-field-textarea";
import {GvfUiService} from "../../gvf/js/gvf-ui-service";
import {FormFieldSelectImage} from "../components/form-field-select-image/form-field-select-image";
import {ModHeader} from "../components/mod-header/mod-header";
import {ModFooter} from "../components/mod-footer/mod-footer";
import {FormFieldHtml} from "../components/form-field-html/form-field-html";
import {ModalFormButton} from "../components/modal-form-button/modal-form-button";
import {FormFieldFiles} from "../components/form-field-files/form-field-files";
import {DropzoneComponent} from "../components/dropzone/dropzone-component";
import {ModCookies} from "../components/mod-cookies/mod-cookies";


GvfUiService.registerComponent(".js-body",BodyComponent);
GvfUiService.registerComponent(".js-form",Form);
GvfUiService.registerComponent(".js-form-field",FormField);
GvfUiService.registerComponent(".js-form-field-checks",FormFieldChecks);
GvfUiService.registerComponent(".js-form-field-date",FormFieldDate);
GvfUiService.registerComponent(".js-form-field-input",FormFieldInput);
GvfUiService.registerComponent(".js-form-field-radio",FormFieldRadio);
GvfUiService.registerComponent(".js-form-field-select",FormFieldSelect);
GvfUiService.registerComponent(".js-form-field-select-image",FormFieldSelectImage);
GvfUiService.registerComponent(".js-form-field-textarea",FormFieldTextarea);
GvfUiService.registerComponent(".js-form-field-html",FormFieldHtml);
GvfUiService.registerComponent(".js-form-field-files",FormFieldFiles);
GvfUiService.registerComponent(".js-mod-header",ModHeader);
GvfUiService.registerComponent(".js-mod-footer",ModFooter);
GvfUiService.registerComponent(".js-mod-cookies",ModCookies);
GvfUiService.registerComponent(".js-modal-form-button",ModalFormButton);
GvfUiService.registerComponent(".js-dropzone",DropzoneComponent);

GvfUiService.registerDelayedComponent(".js-mod-gvml",()=>import("../components/mod-gvml/mod-gvml"));
GvfUiService.registerDelayedComponent(".js-mod-location-principal",()=>import("../components/mod-location-principal/mod-location-principal"));
GvfUiService.registerDelayedComponent(".js-mod-location-detail",()=>import("../components/mod-location-detail/mod-location-detail"));
GvfUiService.registerDelayedComponent(".js-mod-offer",()=>import("../components/mod-offer/mod-offer"));
GvfUiService.registerDelayedComponent(".js-mod-contact-module",()=>import("../components/mod-contact-module/mod-contact-module"));
GvfUiService.registerDelayedComponent(".js-mod-bannernewsletter",()=>import("../components/mod-bannernewsletter/mod-bannernewsletter"));
GvfUiService.registerDelayedComponent(".js-mod-offer-detail",()=>import("../components/mod-offer-detail/mod-offer-detail"));
GvfUiService.registerDelayedComponent(".js-mod-offer-information",()=>import("../components/mod-offer-information/mod-offer-information"));

GvfUiService.registerDelayedComponent(".js-mod-news",()=>import("../components/mod-news/mod-news"));
//GvfUiService.registerDelayedComponent(".js-rep-file-list-page",()=>import("../components/rep-file/rep-file-list-page"));
